import React from 'react';
import './ValuesQ3.scss';
import ValuesQuestion from '../shared/ValuesQuestion.jsx'
const locator = require('./Locator_2.png')

const definitelyPic = require('./Def_pink.png')
const probablyPic = require('./Prob_pink.png')
const doesntMatterPic = require('./DsntMatter_pink.png')
const probablyNotPic = require('./ProbNot_pink.png')
const definitelyNotPic = require('./DefNot_pink.png')

const definitelyDesktopPic = require('./desktop/Def_pink.png')
const probablyDesktopPic = require('./desktop/Prob_pink.png')
const doesntMatterDesktopPic = require('./desktop/DsntMatter_pink.png')
const probablyNotDesktopPic = require('./desktop/ProbNot_pink.png')
const definitelyNotDesktopPic = require('./desktop/DefNot_pink.png')
const ValuesQ3 = ({ answer, setAnswer, lexicon, answersLexicon, studyId }) => {

  return (
    <div id="ValuesQ3">
        <ValuesQuestion 
          question="q3"
          answer={answer} 
          setAnswer={setAnswer} 
          lexicon={lexicon} 
          answersLexicon={answersLexicon} 
          definitelyPic={definitelyPic} 
          probablyPic={probablyPic} 
          doesntMatterPic={doesntMatterPic} 
          probablyNotPic={probablyNotPic} 
          definitelyNotPic={definitelyNotPic} 
          definitelyDesktopPic={definitelyDesktopPic} 
          probablyDesktopPic={probablyDesktopPic} 
          doesntMatterDesktopPic={doesntMatterDesktopPic} 
          probablyNotDesktopPic={probablyNotDesktopPic} 
          definitelyNotDesktopPic={definitelyNotDesktopPic} 
          backPath="/values-q2"
          nextPath="/values-q4"
          locator={locator}
          studyId={studyId}
        />
    </div>
  );
}

export default ValuesQ3 ;
